class FundingDocumentModalController {
  constructor($rootScope, $scope, $uibModalInstance, $interval, $timeout, $http) {
      "ngInject";
      this.name = 'FundingDocumentModal';
      $scope.fundingMods = $uibModalInstance.fundingMods;
      $scope.projectId = $uibModalInstance.projectId;
      $scope.apiHost = $uibModalInstance.apiHost;

      // Sync documentCount since we use a separate component to manage
      // documents.  When the modal is closed, we communicate the updated count
      // to the parent component.
      $scope.documentCount = $uibModalInstance.fundingMods.length
      $scope.updateDocumentCount = (count) => {
        $scope.documentCount = count
      }

      $scope.cancel = function() {
        $uibModalInstance.count = $scope.documentCount
        $uibModalInstance.cancel($scope.documentCount)
      }

      this.$http = $http;
      this.$scope = $scope;
      $scope.selectedFile;
      this.$rootScope = $rootScope;
      $scope.documentApiUrl = `${$rootScope.apiHost}/api/admin/projects/${$scope.projectId}/fundingdocuments`
  }

}

export default FundingDocumentModalController;



// WEBPACK FOOTER //
// ./client/common/modals/fundingDocumentModal/fundingDocumentModal.controller.js